/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(window).on('load resize orientationchange', function () {
  $('.o-layout__item').each(function(i, v) {
    var height = $(v).find('.product-top').outerHeight() - $(v).find('.open_variant_option').outerHeight();
    $(v).find('.product-btn').css('top', height+'px');
    $(v).find('.variant_wrapper').css('bottom', $(v).find('.open_variant_option').outerHeight()+'px');
    var button = $(v).find('.open_variant_option').outerHeight();
    $(v).find('.variant_wrapper').css('height', 'calc(100% - '+button+'px)');
    $(v).find('.product-btn').show();
  });
});

$(document).ready(function() {
  setTimeout(function() {
    $('.o-layout__item').each(function(i, v) {
      var height = $(v).find('.product-top').outerHeight() - $(v).find('.open_variant_option').outerHeight();
      $(v).find('.product-btn').css('top', height+'px');
      $(v).find('.variant_wrapper').css('bottom', $(v).find('.open_variant_option').outerHeight()+'px');
      var button = $(v).find('.open_variant_option').outerHeight();
      $(v).find('.variant_wrapper').css('height', 'calc(100% - '+button+'px)');
      $(v).find('.product-btn').show();
    });
  }, 2000);

  $('body').on('click', '.open_variant_option.no_redirect', function(e) {
    e.preventDefault();
    var def_text = $(this).data('default-text');
    $(this).parent().toggleClass('active');
    if ($(this).parent().hasClass('active')) {
      $(this).text('CANCEL');
    } else {
      $(this).text(def_text);
    }
    var element = $(this).parents('.product');
    element.find('.variant_wrapper').slideToggle(400);
  });
});


/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});


$(document).ready(function(){
  function update(id,ip){
      $.ajax({
      type: 'POST',
      url: '/cart/update.js', 
      data: 'updates['+id+']='+ip,
      dataType: 'json', 
      success: function() {
        location.reload()
      }
    });
  }
  $("body").on("click",".our-packages-btn",function(e){
     e.preventDefault();
     var form = $(this).closest('form');       
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: form.serialize(),
        success: function() {
        window.location.href="/checkout";
       }
     });
  });
  $('body').on('change','.ajaxcart__qty-num',function(){
    var ajaxcart__qty= $(".ajaxcart__qty-num");
    var matchvalue =parseInt(ajaxcart__qty.val());     
    var pro_id = $(this).parents(".cart__products").find(".cart__product").attr('data-id');
    setTimeout(update(pro_id,matchvalue), 100);
  });
  $('body').on('click', '.cart-form .js-qty__adjust', function() {
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if ($(this).hasClass('ajaxcart__qty--plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip == 0) {
      return false;
    }
    input.val(ip);
    var id = $(this).parents(".cart__products").find(".cart__product").attr('data-id');
    var quantityVal = $("input[name='quantity']").val();
     update(id,quantityVal) 
  });
  $("body").on("click",".cart-shipping-toggle",function(){
    $('#shipping-calculator').toggleClass('open');
    if( $('#shipping-calculator').hasClass('open')){
      $(this).html('Hide Calculate Shipping');
    } else {
      $(this).html('Calculate Shipping');
    }
  });  
});